import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const ExteriorColorDescription = ({ exteriorColorDescription }: SpecProps<"exterior_color_description">) => {
  const { i18n } = useLingui();

  if (exteriorColorDescription == null || exteriorColorDescription === "") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.exterior_color_description",
    message: "Exterior color description",
    comment: "Field for 'exterior color description' in ad specification",
  });
  return <FieldValuePair field={field} value={exteriorColorDescription} />;
};
